import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="flex w-full flex-col items-center justify-between px-1 pb-8 pt-3 lg:px-8 xl:flex-row">
      <h5 className="mb-4 text-center text-sm font-medium text-gray-600 sm:!mb-0 md:text-lg">
        {/* Optional footer title */}
      </h5>
      <div>
        <ul className="flex flex-wrap items-center gap-3 sm:flex-nowrap md:gap-10">
          <li>
            <a
              href="mailto:cto@coinheatmap.com"
              className="text-base font-medium text-gray-600 hover:text-gray-600"
            >
              Contact
            </a>
          </li>
          <li>
            <Link
              to="/tos"
              className="text-base font-medium text-gray-600 hover:text-gray-600"
            >
              Terms of Service
            </Link>
          </li>
          <li>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://medium.com/@CoinHMAP"
              className="text-base font-medium text-gray-600 hover:text-gray-600"
            >
              Medium
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Footer;
